export default class AppController {}
